
import http from '@/http/index.js'
export default {
  namespaced: true,
  state: {
    userInfo: {}

  },
  mutations: {
    setUserInfo(state, info) {
      state.userInfo = info;
    }

  },
  actions: {
    async getUserInfo(ctx) {
      const res = await http.user.getInfo()

      ctx.commit('setUserInfo', res)
    }
  }
};
